module.exports = __webpack_public_path__ + "static/media/loc1_img4.5d71affe.jpg";